import React from 'react';
import { Button, SxProps, Theme } from '@mui/material';
import { commonButtonProps } from './commonButtonInterface';

const SaveButton: React.FC<commonButtonProps> = ({
  buttonText,
  onClick,
  sx = {},
  icon: IconComponent,
}) => {
  const buttonStyles: SxProps<Theme> = {
    borderRadius: {
      xxl: '0.5rem',
      xl: '0.5rem',
      lg: '0.438rem',
      md: '0.413rem',
    },
    padding: { xl: '0.5rem 0.8rem !important', lg: '0.4rem 0.7rem' },
    fontSize: {
      xxl: '1.1rem',
      xl: '0.9rem',
      lg: '0.8rem',
      md: '0.7rem',
    },
    backgroundColor: '#0052CC',
    color: 'white',
    '&:hover': {
      backgroundColor: '#0052CC',
      color: 'white',
    },
    ...sx,
  };

  return (
    <Button
      sx={buttonStyles}
      onClick={onClick}
      startIcon={IconComponent && <IconComponent />}
    >
      {buttonText}
    </Button>
  );
};

export default SaveButton;
